<template>
  <div id="academica" style="background: white" ref="fullScreenElement">
    <K2Button class="fullScreenButton ms-auto d-table p-3" @onclick="toggleFullScreen()">{{ isFullScreen ? 'Exit' : 'FullScreen' }}</K2Button>

    <iframe :src="passURL" :style="{ height: iframeHeight }" style="width: 100%; zoom: normal; border: 0" width="80%" title="Academica"></iframe>
  </div>
</template>
<script>
import uiVariable from '../../config/uiVariable'
import { lang } from '@/locale'
import { getRole } from '@/helper/util_custom'
import './academica.css'
import K2Button from '@/uiComponents/k2Button/k2Button'

export default {
  name: 'Academica',
  components: { K2Button },
  props: ['url', 'height'],
  data() {
    return {
      uiVariable: uiVariable,
      passURL: '',
      iframeHeight: 'calc(100vh - 190px)',
      isFullScreen: false,
    }
  },
  mounted() {
    if (this.$route.params.url) {
      this.passURL = this.$route.params.url
    }

    if (this.url) {
      this.passURL = this.url
    }

    if (getRole() === 'Parent') {
      this.iframeHeight = 'calc(100vh - 130px)'
    }

    document.body.className = 'academica'
  },
  watch: {
    url: function (value) {
      console.log(value, 'url')
      if (value) {
        this.passURL = value
      }
    },
    height: function (value) {
      this.iframeHeight = value
    },
  },
  methods: {
    lang,
    toggleFullScreen() {
      const elem = this.$refs.fullScreenElement
      this.isFullScreen = !this.isFullScreen
      if (document.fullscreenElement) {
        document.exitFullscreen()
      } else {
        elem.requestFullscreen().catch(err => {
          console.error('Failed to enter fullscreen mode:', err)
        })
      }
    },
  },
}
</script>
